import { OpsiumPolicy } from '@/modules/common/types/opsium-policy';
import { decryptJson } from '@/utils/encryption';

import { OpsiumUserProfileResponse } from '../types/dto/response/opsium-user-profile-response';
import { MyOpsiumUserProfile } from '../types/opsium-user-profile';

const ENCRYPTION_KEY = import.meta.env.VITE_RESPONSE_ENCRYPTION_KEY;

/**
 * Maps OpsiumUserProfileResponse (API response) to OpsiumUserProfile (domain model)
 * Decrypts the policies field which comes encrypted from the backend
 */
export const mapOpsiumUserProfileFromResponse = async (
  response: OpsiumUserProfileResponse
): Promise<MyOpsiumUserProfile> => {
  let policies: OpsiumPolicy[] = [];

  if (response.policies && ENCRYPTION_KEY) {
    policies = await decryptJson<OpsiumPolicy[]>(response.policies, ENCRYPTION_KEY);
  }

  return {
    id: response.id,
    email: response.email,
    name: response.name,
    profileImageUrl: response.profileImageUrl,
    userGroup: response.userGroup,
    policies,
  };
};
